// extracted by mini-css-extract-plugin
export default {"price":"Q_-z","onSale":"R_-z","msrpLabelPrice":"S_-z","msrpLabel":"T_-z","originalPrice":"U_-z","percentOff":"V_-z"};